import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {config} from '../../../config';
import {parseMessageSegments} from '../../../lib/shared/errors/message-text';

/**
 * Renders message-code text -- an error `message` from the API, or the client's own copy -- without
 * a sanitization bypass. Text goes through interpolation, a line break becomes `<br/>`, and a
 * `{support:key}` placeholder becomes a `tel:` link to that `config.support` number. Markup in the
 * text renders as literal characters, which matters because ITK0001's message embeds clinic data.
 *
 * Lives app-side rather than in `lib/shared` because it reads `config`, which the lib never imports.
 */
@Component({
  selector: 'app-message-text',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    @for (segment of segments(); track $index) {
      @if (segment.kind === 'text') {
        <ng-container>{{ segment.value }}</ng-container>
      } @else if (segment.kind === 'break') {
        <br/>
      } @else {
        <a class="link blend {{ linkClass() }}" [href]="'tel:+' + segment.number">{{ segment.number }}</a>
      }
    }
  `,
})
export class MessageTextComponent {
  readonly text = input<string | null | undefined>(null);

  /** Class on each support link. Piwik tracks the clicks by it, so it must not change per screen by accident. */
  readonly linkClass = input('pk_dialog_intake', {
    transform: (value: string | null | undefined) => value || 'pk_dialog_intake',
  });

  // `config.support` reads `supportProfile` inside its proxy, so a referral visit re-renders the numbers
  protected readonly segments = computed(() => parseMessageSegments(this.text(), config.support));
}
